import React from "react";

export const Subheading: React.FC<{ text: string }> = (props) => {
    const { text } = props;

    return (
        <div
            style={{
                paddingTop: 8,
                paddingBottom: 4,
                fontWeight: "bold",
            }}
        >
            {text}
        </div>
    );
};
